// features/credential.dependencies.js

export const loadCredentialDependencies = async () => {
  return {};
};
